export default __webpack_public_path__ + "static/media/content.d4a3c8f7.svg";